import React from 'react';
import { saveAs } from 'file-saver';
import { MdDownload } from 'react-icons/md';
import PortalButton from './PortalButton';
import { usePortalDownload } from '../hooks';
import { ErrorNotice } from './Feedback';

export default function FormFileAnswer({ application, field }) {
  const download = usePortalDownload();
  const record = application.form_files?.find(
    (file) => file.id === application.data?.[field.id] && file.field_id === field.id
  );
  if (!record) return <>—</>;
  const path = `inscricoes/${application.id}/arquivos-formulario/${record.id}/download`;
  return (
    <>
      <span className="d-block mb-2">{record.file_name}</span>
      <PortalButton
        className="btn btn-secondary hidethis"
        disabled={download.isLoading || !download.allowed(path)}
        onClick={() =>
          download.mutate({ path }, { onSuccess: (blob) => saveAs(blob, record.file_name) })
        }
      >
        <MdDownload /> Baixar arquivo
      </PortalButton>
      <ErrorNotice error={download.error} />
    </>
  );
}
